
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import BasketModule from '@/store/modules/basket';

@Component({
  components: {
  }
})
export default class SingleFavorite extends Vue {
  @Prop({ type: Number, default: null }) id: number;
  @Prop({ type: Boolean, default: false }) isDefault: boolean;
  @Prop({ type: String, default: '' }) name: string;
  @Prop({ type: Array, default: () => [] }) products: FavoriteOrderProductModel[];
  @Prop({ type: Number, default: null }) vendorId: number;
  @Prop({ type: String, default: '' }) vendorName: string;

  async handleOrder(favoriteId) {
    const loader = this.$loading.show();
    try {
      await BasketModule.createBasketFromFavorite({ favoriteId });
      this.$emit('handle-reorder');
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    } finally {
      loader.hide();
    }
  }

  get itemCountText() {
    if (this.products.length === 1) {
      return '1 item';
    }
    return `${this.products.length} items`;
  }

  @Emit('previewOrder')
  previewOrder() {
    return { ...this.$props, ...this.$attrs };
  }
}
